import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const PayerMappingsTableRowComponent: React.FunctionComponent<
    IPayerMappingsTableRowComponentProps
> = props => {
    return (
        <div
            className={`
                relative p-[16px]
                border-b border-solid border-brand-warmLight
                md:mt-[24px] md:border md:rounded-[8px]
                md:border-brand-warmShadow
                ${props.error ? "bg-brand-paleRed" : "md:bg-brand-whitePurple"}
            `}
        >
            <div className="flex items-center gap-[8px] md:block">
                <PrimaryText className="flex-3 md:mt-[8px] md:w-auto">
                    <span className="opacity-50 hidden md:inline-block">
                        Payer Name:&nbsp;
                    </span>

                    {props.externalName}
                </PrimaryText>

                <PrimaryText className="flex-2 md:mt-[8px] md:w-auto">
                    <span className="opacity-50 hidden md:inline-block">
                        Payer ID:&nbsp;
                    </span>

                    {props.externalPayerId}
                </PrimaryText>

                <PrimaryText className="flex-2 md:mt-[8px] md:w-auto">
                    <span className="opacity-50 hidden md:inline-block">
                        Nirvana Payer ID:&nbsp;
                    </span>

                    {props.payerId}
                </PrimaryText>

                {props.actions}
            </div>

            {props.error ? (
                <div className="text-[13px] text-brand-error2 font-medium mt-[8px]">
                    {props.error}
                </div>
            ) : null}
        </div>
    )
}

interface IPayerMappingsTableRowComponentProps {
    externalName?: string | null
    externalPayerId: string
    payerId: string
    error?: string
    actions?: React.ReactNode
}
